module.exports = __webpack_public_path__ + "img/bt3_act.1fe2ed9c.png";